import { useEffect, useMemo } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useAuth } from './auth.js';

// A cache belongs to one authenticated identity/session, never to the browser.
export function SessionQueryProvider({ children }: { children: React.ReactNode }) {
  const { account, sessionEpoch } = useAuth();
  const client = useMemo(() => new QueryClient({ defaultOptions: {
    queries: { staleTime: 15_000, retry: 1, refetchOnWindowFocus: false },
    mutations: { retry: false }
  } }), [account?.id, account?.organizationId, sessionEpoch]);
  useEffect(() => () => { void client.cancelQueries(); client.clear(); }, [client]);
  return <QueryClientProvider key={`${sessionEpoch}:${account?.organizationId ?? ''}:${account?.id ?? ''}`} client={client}>{children}</QueryClientProvider>;
}
